import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { z } from 'zod'
import { zodSearchValidator } from '@tanstack/router-zod-adapter'
import { Button, Card, Flex, Input, message } from 'antd'

import { useState } from 'react'
import { supabase } from '../../../utils/supabase'
import { trackEvent } from '../../../utils/Matomo/tracking_functions'
import { COLORS } from '@next-is-free-monorepo/globals'
import posthog from 'posthog-js';
import { apiV1 } from '../../../utils/apiClient';
import * as React from 'react';

const productSearchSchema = z.object({
  email: z.string().email(),
})

export const Route = createFileRoute('/_public/confirm-email')({
  component: RouteComponent,
  validateSearch: zodSearchValidator(productSearchSchema),
  onError: (err) => {
    throw redirect({ to: '/sign-up' })
  },
})

function RouteComponent() {
  const [opt, setOpt] = useState<string>('')

  const { email } = Route.useSearch()

  async function verifyCode() {
    const { data, error } = await supabase.auth.verifyOtp({
      email,
      token: opt,
      type: 'email',
    })
    if (error) {
      message.error('Codice errato')
      return
    }
    if (data) {
      posthog.capture('email_verified', { email: data.user?.email });
      if(data.user?.user_metadata?.signup_privacy_consent){
        await apiV1.post('/shop/privacy-settings', {email: data.user?.user_metadata.signup_privacy_consent, tracking: data.user?.user_metadata.signup_privacy_consent, push_notifications: data.user?.user_metadata.signup_privacy_consent, onboarded: false})
      }
      window.location.reload()
    }
  }

  async function resend() {
    await supabase.auth.resend({
      type: 'signup',
      email: email,
      options: {
        emailRedirectTo: 'https://app.nextisfree.io/welcome/',
      },
    })
  }

  return (
      <div>
        <div className={'text-center mb-10'}>
          <h1 className={'font-bold text-3xl text-center'}>Verifica indirizzo email</h1>
          <p className={'mt-2 text-slate-500 text-sm text-balance'}>Ti abbiamo inviato una email a: {email} per verificare il tuo
            indirizzo email. Clicca su "Verifica Email" per continuare o inserisci
            il codice di verifica.</p>
        </div>
        <div className={'w-full flex items-center flex-col gap-5'}>
          <Input.OTP
            size={'large'}
            length={6}
            onChange={(value) => {
              setOpt(value)
            }}
          />
          <Button
            onClick={verifyCode}
            size={'large'}
            type={'primary'}
            className={'w-full max-w-[300px] bg-primary text-black rounded-xl'}
          >
            Verifica
          </Button>
        </div>

        <h3 style={{ marginTop: 30, textAlign: 'center' }}>
          Non vedi l'email?
        </h3>
        <p style={{ textAlign: 'center' }}>
          Controlla la cartella spam o{' '}
          <a
            onClick={resend}
            style={{ color: 'black', textDecoration: 'underline' }}
          >
            invia di nuovo
          </a>
        </p>
      </div>
  )
}
